import { useState } from 'react';
import {
  useRive,
  useStateMachineInput,
  RiveFile,
} from '@rive-app/react-webgl2';
import { join, insertIf } from 'lib/helpers';
import styles from './OpenInRiveButton.module.css';
import { siteAnimationOpenInRive } from 'lib/analytics';

type Props = {
  title: string;
  display: boolean;
  url: string;
  openInRiveFile?: RiveFile;
};

const OpenInRiveButton = ({ title, display, url, openInRiveFile }: Props) => {
  const { RiveComponent, rive } = useRive({
    riveFile: openInRiveFile,
    stateMachines: 'controller',
    autoplay: true,
  });

  const onHoverInput = useStateMachineInput(rive, 'controller', 'onHover');
  const onClickInput = useStateMachineInput(rive, 'controller', 'onClick');
  const [onHover, setOnHover] = useState<boolean>(false);

  function onHoverStart() {
    if (onHoverInput) {
      onHoverInput.value = true;
      setOnHover(true);
    }
  }

  function onHoverEnd() {
    if (onHoverInput) {
      onHoverInput.value = false;
      setOnHover(false);
    }
  }

  function onClick(e: React.MouseEvent<HTMLElement>) {
    if (onClickInput) {
      onClickInput.fire();
    }
    window.open(url, '_blank');
    siteAnimationOpenInRive(title);
    e.stopPropagation();
    e.preventDefault();
  }

  return (
    <div
      className={join([
        styles.Container,
        ...insertIf(display, styles.Display),
        ...insertIf(onHover, styles.Open),
      ])}
      onMouseLeave={onHoverEnd}
    >
      <RiveComponent onClick={onClick} />;
      <div
        className={join([
          styles.TriggerBounds,
          ...insertIf(onHover, styles.Hidden),
        ])}
        onMouseEnter={onHoverStart}
      />
    </div>
  );
};

export default OpenInRiveButton;
